// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea659c91","455":"924b07d6"}[chunkId] + ".chunk.js";
};